import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { SpeedInsights } from '@vercel/speed-insights/next'
import { ThemeContextProvider } from '@/contexts/ThemeContext'
import { Analytics } from '@/layout/Analytics'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { DefaultSeo } from '@/layout/Seo'
import { LanguagesProvider } from '@/molecules/LanguageSelector'
import { ToastProvider } from '@/molecules/Toast/ToastProvider'
import { MasqueradeBanner } from '@/organisms/MasqueradeBanner'
import type { SiteNavProps } from '@/organisms/SiteNav/SiteNav'
import { getWebClient } from '@/services/ApolloClient'
import { useLocale } from '@/utils/LocaleUtil'

export interface BaseLayoutProps {
  children: React.ReactNode
  isDarkMode: boolean
  footerComponent?: React.ReactNode
  siteNavProps?: SiteNavProps
}

export const BaseLayout: React.FC<BaseLayoutProps> = ({ children, isDarkMode }) => {
  const { locale } = useLocale()
  const client = getWebClient({ locale })

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <DefaultSeo />
      <LanguagesProvider>
        <Analytics>
          <ApolloProvider client={client}>
            <ThemeContextProvider isDarkMode={isDarkMode}>
              <ToastProvider>
                <MasqueradeBanner />
                {children}
                <SpeedInsights sampleRate={0.1} />
              </ToastProvider>
            </ThemeContextProvider>
          </ApolloProvider>
        </Analytics>
      </LanguagesProvider>
    </ErrorBoundary>
  )
}
